/**
 * Default copy for platform page intros (ⓘ modal body).
 * Pages may override infoBody when context-specific.
 */
export const PLATFORM_PAGE_INTROS = Object.freeze({
  home: {
    primary: "Home",
    secondary: "Today",
    infoTitle: "About Home",
    infoBody:
      "Your rally HQ — resume play, see season stats, recent matches, and what to do next. Create a match or jump to Discover when you are ready to compete.",
  },
  arena: {
    primary: "Arena",
    infoTitle: "About Arena",
    infoBody:
      "Your arena for live scoring. Active arenas are ready to open. Past arenas may have been removed by the host or inactive for 15 days — tap to try again.",
  },
  discover: {
    primary: "Discover",
    secondary: "Explore",
    infoTitle: "About Discover",
    infoBody:
      "Search players, clubs, tournaments, and rankings — one place to explore the RallyAlly ecosystem.",
  },
  activity: {
    primary: "Activity",
    secondary: "Your feed",
    infoTitle: "About Activity",
    infoBody:
      "Invitations, match updates, tournament news, and unlocks — chronological updates from your notifications.",
  },
  me: {
    primary: "Me",
    secondary: "Profile",
    infoTitle: "About Me",
    infoBody:
      "Account, performance, organizations, and settings. Career stats and recent activity for your player identity.",
  },
  browseCompetitions: {
    primary: "Discover",
    secondary: "Tournaments",
    infoTitle: "About tournaments browse",
    infoBody: "Find upcoming tournaments and register to play. Filter by status, location, and category.",
  },
  playerSearch: {
    primary: "Discover",
    secondary: "Players",
    infoTitle: "About player search",
    infoBody: "Find players by name, club, country, or state. Open a profile to view career and rankings.",
  },
  rankings: {
    primary: "Discover",
    secondary: "Rankings",
    infoTitle: "About rankings",
    infoBody:
      "Public leaderboards projected from completed match history and tournament placements. Tournament scoring is never modified.",
  },
  organizations: {
    primary: "Discover",
    secondary: "Organizations",
    infoTitle: "About organizations",
    infoBody: "Browse clubs, academies, and associations. Open a profile to see members and hosted events.",
  },
  yourArenas: {
    primary: "Me",
    secondary: "Your arenas",
    infoTitle: "About your arenas",
    infoBody:
      "Arenas you created or joined on this device. Enter to score or play; invite shares join codes (spectator link only).",
  },
});
